export default __webpack_public_path__ + "static/media/address.103b045f.svg";